import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import MediaCard from '@redbubble/design-system/react/MediaCard';
import * as constants from '@redbubble/design-system/react/constants';
import ProductPrice from '../ProductPrice';

const REF = 'explore-shop-product';

const ProductCard = ({ item, showStrikethroughPricing }) => {
  const { description, productPageUrl, preview } = item;
  const previewUrl = get(preview, 'url');
  return (
    <MediaCard
      title={description}
      element="a"
      href={`${productPageUrl}?ref=${REF}`}
      imageRatio={constants.RATIO_SQUARE}
      imageCover
      imageSrc={previewUrl}
      transparent
    >
      <ProductPrice
        inventoryItem={item}
        showStrikethroughPricing={showStrikethroughPricing}
      />
    </MediaCard>
  );
};

ProductCard.propTypes = {
  item: PropTypes.shape({
    description: PropTypes.string.isRequired,
    preview: PropTypes.shape({
      url: PropTypes.string.isRequired
    }).isRequired,
    price: PropTypes.shape({
      amount: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired
    }).isRequired,
    volumeDiscount: PropTypes.shape({
      thresholds: PropTypes.arrayOf(
        PropTypes.shape({
          quantity: PropTypes.number.isRequired,
          percentOff: PropTypes.string.isRequired
        })
      )
    }),
    productPageUrl: PropTypes.string.isRequired
  }).isRequired,
  showStrikethroughPricing: PropTypes.bool
};

ProductCard.displayName = 'ProductCard';
export default ProductCard;
